import React, { Component } from "react";
import { connect, ReactReduxContext } from "react-redux";
import { Modal } from "semantic-ui-react";
import {
  updateSendCancellationEmailToggle,
  updateStoreCardForLaterModalVisibility,
} from "../../../actions/menu";
import { updateBooking, sendBookingEmail } from "../../../actions/booking";
import { Checkbox } from "semantic-ui-react";
import { toApiDateTime } from "../../../utils/helpers";
import CreditCardPaymentForm from "../../pages/appointment-checkout/components/creditCardPaymentForm";
import { Dimmer, Loader } from "semantic-ui-react";
import { saveAppointmentDataHandler } from "../functions/saveAppointmentDataHandler";
import { forceValidation } from "../validMeReact";
import { confirmServicePriceChangeAndGenerateInvoice } from "../functions/confirmServicePriceChangeAndGenerateInvoice";
import { clone } from "../../../reducers/helper";
import { updateAppointmentStepData } from "../../../actions/appointmentStep";
import { getBookingPayments } from "../../../actions/checkoutAppointmentStep";
import { StripeProvider, Elements } from "react-stripe-elements";
import SquareForm from "../../pages/appointment-checkout/components/SquareForm";
import { getPaymentSetting } from "../../../actions/checkoutAppointmentStep";
import objectAssign from "object-assign";

/**
 * FlOW FOR HOW THIS WORKS. Did not write this shit, just had to figure out how it worked
 * SAVE Clicked --> handleSaveClick --> saveAppDataHAndler() --> Dispatches saveBooking( type: SAVE_BOOKING_FORM)
 * Note, callback defined in handleSAveClick, was passed to saveAppDataHandler, lets call it CB_1 which is then passed to SaveBooking saga
 * After SaveBooking Promise resolves it fires CB_1
 * CB_1 runs confirmServicePriceChangeAndGenerateInvoice which dispatches (type: CREATE_INVOICE?)
 * CB_1 was also passed its own callback, lets call it CB_2
 * CB_2 ios defined in the payment forms (Basically just runs the save card flow)
 * So once CB_1 runs, CREATE_INVOICE --> createInvoiceApi saga promise resolves, CB_2 is fired
 */
@connect(mapStateToProps)
export default class StoreCardForLaterModal extends Component {
  closeApp = () => {
    let event = new CustomEvent("messageFromUsToParent", {
      detail: {
        action: "close",
      },
    });
    window.dispatchEvent(event);
  };

  updateStoreCardForLaterModalVisibility = (isVisible) => {
    this.props.dispatch(updateStoreCardForLaterModalVisibility(isVisible));
  };

  getLoadingSpinner = () => {
    const {
      isGettingStripeToken,
      updatingBookingPayments,
      appointmentStepData,
      savingBooking,
      updatingBookingToInvoice,
      paymentSetting,
    } = this.props;

    const isLoading =
      isGettingStripeToken ||
      updatingBookingPayments ||
      appointmentStepData.loadingInvoice ||
      savingBooking ||
      updatingBookingToInvoice ||
      paymentSetting.loading;
    if (!isLoading) {
      return "";
    } else {
      return (
        <Dimmer active={isLoading}>
          <Loader />
        </Dimmer>
      );
    }
  };

  componentDidMount = () => {
    let { currentBookingId } = this.props;
    this.props.dispatch(getPaymentSetting());
    if (currentBookingId) {
      this.props.dispatch(getBookingPayments(currentBookingId));
    }
  };

  afterSaveHandler = () => {
    this.updateStoreCardForLaterModalVisibility(false);
    this.closeApp();
  };

  dispatchUpdateAppointmentStepData = (appointmentStepData) => {
    this.props.dispatch(updateAppointmentStepData(appointmentStepData));
  };

  updateAppointmentStep = (data, multiItemIndex) => {
    let { multiServiceList } = this.props.appointmentStepData;
    let newData = "";
    newData = clone(this.props.appointmentStepData);
    if (multiItemIndex != undefined) {
      newData.multiServiceList[multiItemIndex] = objectAssign(
        {},
        multiServiceList[multiItemIndex],
        data
      );
    } else {
      newData = objectAssign({}, this.props.appointmentStepData, data);
    }
    this.dispatchUpdateAppointmentStepData(newData);
  };

  handleSaveClick = (cb) => {
    let {
      appointmentStepData,
      advancedAppointmentStepData,
      currentBookingId,
      advancedAppointmentStepDataFromLastSave,
      isMultiServiceAppointment,
      gotValidOffer,
      invoiceData,
    } = this.props;
    let areThereErrors = forceValidation(
      null,
      null,
      "firstStepAppointment&secondStepAdvancedAppointment"
    );
    const { posSettings } = this.props;
    const { bookingRevenue } = this.props.checkoutAppointmentStepData;

    const {
      selectedCustomer,
      paymentsEnabled,
      multiServiceList,
    } = appointmentStepData;
    const customerName =
      (selectedCustomer.firstname || "") +
      " " +
      (selectedCustomer.lastname || "");
    let { price, name } = multiServiceList[0].selectedService;

    let serviceName = "";
    let servicePrice = "";
    if (paymentsEnabled) {
      if (invoiceData && invoiceData.key && invoiceData.items) {
        const bookingItem = invoiceData.items.find((invoiceItem) => {
          let invoiceBooking = 0;
          if (invoiceItem.reference) {
            invoiceBooking = parseInt(invoiceItem.reference, 10);
          }

          return invoiceItem.reference == currentBookingId;
        });
        serviceName = bookingItem.description;
        servicePrice = bookingItem.amount;
      }
    } else {
      serviceName = name;
      servicePrice = price;
    }

    let callback;
    if (cb) {
      callback = () => {
        let updateInvoiceWithTokenCallback = () => {
          setTimeout(() => {
            cb();
          }, 10); //this needs to happen async so we wait until we have a booking id and an invoice id
        };
        setTimeout(() => {
          confirmServicePriceChangeAndGenerateInvoice(
            price,
            name,
            0,
            multiServiceList[0],
            this.props.currentBookingId,
            invoiceData,
            appointmentStepData,
            this.updateAppointmentStep,
            bookingRevenue,
            posSettings,
            this.props.dispatch,
            updateInvoiceWithTokenCallback
          );
        }, 0); //this is here so we save the stripe token after we have updated the redux store with the booking id
      };
    }

    if (!areThereErrors) {
      let forceSave = true;
      let closeWhenSaved = true;
      saveAppointmentDataHandler(
        this.props.dispatch,
        appointmentStepData,
        advancedAppointmentStepData,
        currentBookingId,
        advancedAppointmentStepDataFromLastSave,
        callback,
        forceSave,
        isMultiServiceAppointment,
        gotValidOffer,
        closeWhenSaved
      );
    }
  };

  render() {
    const {
      paymentSetting: { type, loading, status, reasons },
      paymentSetting,
    } = this.props;
    console.log("PAYMENT SETTING", paymentSetting);
    return (
      <Modal
        className="bookingdetails-model cancel-appointment-modal transparent-bg no-borders"
        open={true}
      >
        <Modal.Content className="tip_popup transparent-bg">
          <div className="tip_overlay"></div>
          <div className="store-credit-card-box">
            <section className="header">
              {window.APP.LANGUAGE.Shared.PopupWindows.StoreCreditCardTitle}
              <div
                className="close_button"
                onClick={() =>
                  this.updateStoreCardForLaterModalVisibility(false)
                }
              ></div>
            </section>
            {!loading && status === "failed" && (
              <span>{reasons && reasons[0] && reasons[0].description}</span>
            )}
            {!loading && status !== "failed" && (
              <React.Fragment>
                {type === "square" ? (
                  <SquareForm
                    modalMode={true}
                    beforeSaveHandler={this.handleSaveClick}
                    afterSaveHandler={this.afterSaveHandler}
                  />
                ) : (
                  <StripeProvider apiKey={window.APP.stripeKey}>
                    <Elements>
                      <CreditCardPaymentForm
                        modalMode={true}
                        beforeSaveHandler={this.handleSaveClick}
                        afterSaveHandler={this.afterSaveHandler}
                      />
                    </Elements>
                  </StripeProvider>
                )}
              </React.Fragment>
            )}
            {this.getLoadingSpinner()}
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    message: state.globalErrorReducer.message,
    checkoutAppointmentStepData:
      state.appointmentCheckoutReducer.checkoutAppointmentStepData,
    savingBooking: state.bookingReducer.savingBooking,
    isGettingStripeToken: state.appointmentCheckoutReducer.isGettingStripeToken,
    advancedAppointmentStepDataBeforeUserHasMadeAnyChanges:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataBeforeUserHasMadeAnyChanges,
    sendCancellationEmailToggled:
      state.menuReducer.sendCancellationEmailToggled,
    currentBookingId: state.bookingReducer.currentBookingId,
    posSettings: state.appointmentCheckoutReducer.posSettings,
    isMultiServiceAppointment: state.bookingReducer.isMultiServiceAppointment,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    updatingBookingPayments:
      state.appointmentCheckoutReducer.updatingBookingPayments,
    invoiceData: state.appointmentCheckoutReducer.invoiceData,
    updatingBookingToInvoice:
      state.appointmentCheckoutReducer.updatingBookingToInvoice,
    advancedAppointmentStepDataFromLastSave:
      state.advancedAppointmentStepReducer
        .advancedAppointmentStepDataFromLastSave,
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    paymentSetting: state.appointmentCheckoutReducer.paymentSetting,
  };
}
